import { Track } from "@/modules/track/Track";

export function getFragmentRouteForTrack(track: Track) {
  return `${track.trackId}`;
}
